import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-aos"]
const _hoisted_2 = { class: "lg:mt-0 lg:h-screen flex lg:flex-row flex-col lg:mx-auto mx-8 items-center" }
const _hoisted_3 = { class: "flex-1 text-justify" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "mb-6 mx-8 lg:w-1/2 lg:mx-auto" }
const _hoisted_6 = { class: "mx-8 lg:w-1/2 lg:mx-auto mb-12" }
const _hoisted_7 = { class: "flex-1" }
const _hoisted_8 = { class: "lg:w-3/4" }
const _hoisted_9 = ["src"]

import { HomePageSection } from "@/HomePageSection";

import MyCard from "@/components/MyCard.vue";


export default /*#__PURE__*/_defineComponent({
  props: {
  data: HomePageSection,
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`py-16 lg:mt-0 ${__props.data?.classes}`),
    "data-aos": `fade-${__props.data?.fade}`
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", {
          class: "text-4xl mb-4 font-bold text-center",
          innerHTML: __props.data?.title
        }, null, 8, _hoisted_4),
        _createElementVNode("p", _hoisted_5, _toDisplayString(__props.data?.text1), 1),
        _createElementVNode("p", _hoisted_6, _toDisplayString(__props.data?.text2), 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(MyCard, { class: "mx-auto" }, {
            default: _withCtx(() => [
              _createElementVNode("video", {
                src: __props.data?.videoUrl,
                autoplay: "",
                loop: "",
                muted: "",
                controls: "",
                class: "object-contain"
              }, null, 8, _hoisted_9)
            ]),
            _: 1
          })
        ])
      ])
    ])
  ], 10, _hoisted_1))
}
}

})